var React = require('react');
var Shopify = require('./shopify');
var ProductRow = require('./product-row');
var HeaderPage = require('./header-page');
var ScrollToTop = require('./scroll-to-top');
var Reflux = require('reflux');
var ScreenWid = require('./stores/screen-wid-store');

var StepImageLeft = React.createClass({

  rawMarkup: function() {
    return { __html: this.props.stepDesc };
  },

  render: function() {

    return <div className={"row step" + (this.props.noFade ? "" : " fade-in")}>
        <div className="col-sm-6 fitting-step-img-left">
            <div className="for-border">
                <img src={this.props.img}></img>
            </div>
        </div>
        <div className="col-sm-6 text-wrap">
          <p className="lead">{this.props.prefix}</p>
          <h2>{this.props.title}</h2>
          <div dangerouslySetInnerHTML={this.rawMarkup()}></div> 
        </div>
      </div>
  }
});

var StepImageRight = React.createClass({

  rawMarkup: function() {
    return { __html: this.props.stepDesc };
  },

  render: function() {
    return <div className="row step fade-in">
        <div className="col-sm-6 text-wrap">
          <p className="lead">{this.props.prefix}</p>
          <h2>{this.props.title}</h2>
          <div dangerouslySetInnerHTML={this.rawMarkup()}></div> 
        </div>
        <div className="col-sm-6 fitting-step-img-right">
            <div className="for-border">
                <img src={this.props.img}></img>
            </div>
        </div>
      </div>
  }
});

var HeritageBlock = React.createClass({

  render: function() {
    return <div className={'herit-div ' + this.props.cl}>
                <div className="for-border">
                    <div className="img-wrap">
                      <img src={this.props.img}></img>
                    </div>
                    <p className="caption">{this.props.text}</p>
                </div>
           </div>
  }
});

var HeritageBlockCenter = React.createClass({

  rawMarkup: function() {
    return { __html: this.props.text };
  },

  render: function() {
    return <div className="herit-div center">
          <p className="lead">{this.props.title}</p>
          <div className="img-wrap">
            <img src={this.props.img}></img>
          </div>
          <div dangerouslySetInnerHTML={this.rawMarkup()}></div> 
      </div>
  }
});

var HeritageRow1 = React.createClass({

  render: function() {
    return <div id="heritage-row1" className="fade-in">
        <HeritageBlock cl="col-md left" img={this.props.img1} text={this.props.text1} />
        <HeritageBlock cl="col-sm center" img={this.props.img2} text={this.props.text2} />
        <HeritageBlock cl="col-md right" img={this.props.img3} text={this.props.text3} />
      </div>
  }
});

var HeritageRow2 = React.createClass({

  render: function() {
    return <div id="heritage-row2" className="fade-in">
        <HeritageBlock cl="col-sm left" img={this.props.img1} text={this.props.text1} />
        <HeritageBlockCenter img={this.props.img2} text={this.props.text2}
                             title={this.props.centerTitle} />
        <HeritageBlock cl="col-sm right" img={this.props.img3} text={this.props.text3} />
      </div>
  }
});

var HeritageRow3 = React.createClass({

  render: function() {
    return <div id="heritage-row3" className="fade-in">
        <HeritageBlock cl="col-lg" img={this.props.img1} text={this.props.text1} />
        <HeritageBlock cl="col-lg right" img={this.props.img2} text={this.props.text2} />
      </div>
  }
});

module.exports = React.createClass({

  mixins: [ ScrollToTop, Reflux.listenTo(ScreenWid, "screenWidthCrossSM") ],

  unmounted: false,

  getInitialState: function() {

    return { productRow1: [],
             productRow2: [] }
  },

  componentDidMount: function() {

    document.title = "Art of Fit - Ingledew's Shoes";
    
    Shopify.getFeatureProd(this.featuredProductsGot);

    this.scrollToTop('art-of-fit-page');

    if("SM" == ScreenWid.width) {
        var viewportWidth = jQuery(window).width();
        var itemWidth = viewportWidth * 0.6;
        jQuery('.slides').flexslider({
            selector: '.slides-inner > .herit-div',
            animation: 'slide',
            slideshowSpeed: 5000,
            directionNav: false,
            animationLoop: true,
            //itemWidth: itemWidth ,
            //startAt: 2 
         });
        var margin = viewportWidth * 0.2;
        var marginLeft = margin+15;
        var marginRight = margin-15;
        //jQuery('.flex-viewport').css({'margin-left': margin});
        //jQuery('.flex-viewport').css({'margin-right': margin});
    }
  },

  componentWillUnmount: function() {
    this.unmounted = true;
  },

  handleRequestFitting: function() {
    this.props.showFittingReqForm();
  },

  featuredProductsGot: function(products) {
    if (this.unmounted) return;

    var rows = _.take(_.chunk(products, 3), 2);

    this.setState({ productRow1: <ProductRow collection="featured" products={rows[0]} />,
                    productRow2: <ProductRow collection="featured" products={rows[1]} /> });
  },

  render: function() {

    return <div>
            <HeaderPage image={CMS.aof.headerImg} prefix={CMS.aof.headerPrefix}
                        title={CMS.aof.headerTitle} desc={CMS.aof.headerIntro}
                        imageM={CMS.aof.headerImgM} />
            <main id="content" role="main">
                <section id="steps" className="hidden-xs">
                    <div className="container">
                        <StepImageLeft prefix={CMS.aof.step1Prefix}
                                       title={CMS.aof.step1Title}
                                       img={CMS.aof.step1Img}
                                       noFade={true}
                                       stepDesc={CMS.aof.step1Intro.replace(/____/g, '<br/>')} />
                        <StepImageRight prefix={CMS.aof.step2Prefix}
                                        title={CMS.aof.step2Title}
                                        img={CMS.aof.step2Img}
                                        stepDesc={CMS.aof.step2Intro.replace(/____/g, '<br/>')} />
                        <StepImageLeft prefix={CMS.aof.step3Prefix}
                                       title={CMS.aof.step3Title}
                                       img={CMS.aof.step3Img}
                                       stepDesc={CMS.aof.step3Intro.replace(/____/g, '<br/>')} />
                        <div className="row" id="request-row">
                          <button className="btn btn-primary" 
                             onClick={this.handleRequestFitting}>REQUEST A FITTING
                          </button>
                        </div>
                    </div>
                </section>
                <section className="container hidden-xs">
                    {this.state.productRow1}
                </section>
                <section id="middle-image" className="fade-in">
                    <HeaderPage image={CMS.aof.middleImg} imageM={CMS.aof.middleImgM}
                                prefix=""
                                title={CMS.aof.middleTitle} desc={CMS.aof.middleIntro}/>
                </section>
                <section id="heritage" className="container hidden-xs" ref="heritageDesktop">
                    <div id="for-seperator"></div>
                    <HeritageRow1 img1={CMS.aof.heritageImageUL} text1={CMS.aof.heritageTitleUL}
                                  img2={CMS.aof.heritageImageUC} text2={CMS.aof.heritageTitleUC}
                                  img3={CMS.aof.heritageImageUR} text3={CMS.aof.heritageTitleUR} />
                    <HeritageRow2 img1={CMS.aof.heritageImageML} text1={CMS.aof.heritageTitleML}
                                  img2={CMS.aof.heritageImageCen} text2={CMS.aof.heritageDescCen.replace(/____/g, '<br/>')}
                                  img3={CMS.aof.heritageImageMR} text3={CMS.aof.heritageTitleMR} 
                                  centerTitle={CMS.aof.heritTitleCen}/>
                    <div id="row3">
                      <div className="col-md-10 col-md-offset-1">
                        <HeritageRow3 img1={CMS.aof.heritageImageLL} text1={CMS.aof.heritageTitleLL}
                                      img2={CMS.aof.heritageImageLR} text2={CMS.aof.heritageTitleLR} />
                      </div>
                    </div>
                </section>
                <div ref="heritageMobile" id="heritage-mobile" className="container visible-xs-block">
                    <HeritageBlockCenter img={CMS.aof.heritageImageCen}
                                         text={CMS.aof.heritageDescCen.replace(/____/g, '<br/>')}
                                         title={CMS.aof.heritageTitleCen} />
                    <div className="slides-container">
                        <div className="slides">
                            <div className="slides-inner">
                                <HeritageBlock img={CMS.aof.heritageImageUCM}
                                               text={CMS.aof.heritageTitleUC} />
                                <HeritageBlock img={CMS.aof.heritageImageURM}
                                               text={CMS.aof.heritageTitleUR} />
                                <HeritageBlock img={CMS.aof.heritageImageMRM}
                                               text={CMS.aof.heritageTitleMR} />
                                <HeritageBlock img={CMS.aof.heritageImageLRM}
                                               text={CMS.aof.heritageTitleLR} />
                                <HeritageBlock img={CMS.aof.heritageImageLLM}
                                               text={CMS.aof.heritageTitleLL} />
                                <HeritageBlock img={CMS.aof.heritageImageMLM}
                                               text={CMS.aof.heritageTitleML} />
                                <HeritageBlock img={CMS.aof.heritageImageULM}
                                               text={CMS.aof.heritageTitleUL} />
                            </div>
                        </div>
                    </div>
                </div>
                <section className="container hidden-xs" id="aof-product-row2">
                    {this.state.productRow2}
                </section>
            </main>
        </div>
  }
});